import { render } from "./PDDOrderlist.vue?vue&type=template&id=17cc6ab6&scoped=true"
import script from "./PDDOrderlist.vue?vue&type=script&lang=js"
export * from "./PDDOrderlist.vue?vue&type=script&lang=js"

import "./PDDOrderlist.vue?vue&type=style&index=0&id=17cc6ab6&scoped=true&lang=css"

import exportComponent from "D:\\project\\idbrand\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17cc6ab6"]])

export default __exports__